const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Assets",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M22.946,20.744a4.557,4.557,0,0,0-3.134,1.247l-6.48-4.2a4.565,4.565,0,0,0,.032-3.147l6.753-4.367a4.566,4.566,0,1,0-1.284-1.591l-6.56,4.242a4.575,4.575,0,1,0-.066,6.556l6.47,4.2a4.574,4.574,0,1,0,4.269-2.934Zm0-16.6a2.541,2.541,0,1,1-2.541,2.541A2.544,2.544,0,0,1,22.946,4.141ZM9.054,18.711A2.542,2.542,0,1,1,11.6,16.169,2.544,2.544,0,0,1,9.054,18.711ZM22.946,27.86a2.542,2.542,0,1,1,2.542-2.542A2.544,2.544,0,0,1,22.946,27.86Z",
    style: {
      fill: "#596975"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.2483ac4898b2af4f196d322c38de063c.svg";
export { ForwardRef as ReactComponent };